/********************* 中断请求 *********************/
import store from '../store/index'
export default class abortHttp{
    constructor(config) {
        this.$httpRequestList = new Map();
        this.store = store;
    }
    addAbort(config){
        // 确认需要记录的数据
        if(this.store.state.projectConfig.isRememberHttpForAbort){
            const controller = new AbortController();
            config.signal = controller.signal;
            let signUrl = config.method + '&' + config.url;
            this.$httpRequestList.set(signUrl, controller)
        }
    }
    cancelSingleAbort(config){
        let signUrl = config.method + '&' + config.url;
        let abortController = this.$httpRequestList.get(signUrl);
        if(abortController) {
            abortController.abort();
            this.$httpRequestList.delete(signUrl)
        }

    }
    deleteSingAbort(config){
        let signUrl = config.method + '&' + config.url;
        this.$httpRequestList.delete(signUrl);
    }
    cancelAllAbort(){
        this.$httpRequestList.forEach((value, key) =>{
            if(value) {
                value.abort();
            }
            this.$httpRequestList.clear()
        })
    }
    // 用处不大，可自行操作
    getAbortMap(){
        return this.$httpRequestList;
    }
}